import { useEffect } from "react";
import { createEcho } from "../utils/echo";

const notifyNewMessage = (event: any) => {
  if (!("Notification" in window)) return;

  if (Notification.permission === "granted") {
    new Notification(event.sender?.name || "New message", {
      body: event.message || "📎 Sent an attachment",
      icon: "/logo.png",
    });
  } else if (Notification.permission !== "denied") {
    Notification.requestPermission();
  }
};

export const useChatNotifications = () => {
  useEffect(() => {
    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("userId");
    if (!token || !userId) return;

    const echo = createEcho(token);
    const channelName = `chat.client.${userId}`;

    const channel = echo.private(channelName);

    channel.listen(".message.sent", (event: any) => {
      const inChatSupport = localStorage.getItem("in_chat_support");

      // 🔔 Notify ONLY if user is NOT inside ChatSupport module
      if (!inChatSupport) {
        notifyNewMessage(event);
      }
    });

    return () => {
      channel.stopListening(".message.sent");
    };
  }, []);
};
